import { render, staticRenderFns } from "./product-card.view.vue?vue&type=template&id=e1dafc6e&scoped=true&lang=pug"
import script from "./product-card.view.vue?vue&type=script&lang=ts"
export * from "./product-card.view.vue?vue&type=script&lang=ts"
import style0 from "./product-card.view.vue?vue&type=style&index=0&id=e1dafc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dafc6e",
  null
  
)

export default component.exports